export function companyUserStatusLabel(status, blockedStatus) {
    let statusLabel;
    if (blockedStatus && blockedStatus != 'NONE') {
        statusLabel = 'company.user-status.blocked'
    } else {
        statusLabel = ({
            UNKNOWN: 'company.user-status.unkonwn',
            ACTIVE: 'company.user-status.active',
            PENDING: 'company.user-status.pending',
            PAUSED: 'company.user-status.paused',
        })[status];
    }
    return statusLabel;
}

export function companyUserStatusIconClass(status, blockedStatus) {
    let statusIconClass;
    if (blockedStatus && blockedStatus != 'NONE') {
        statusIconClass = 'fa fa-lg fa-ban'
    } else {
        statusIconClass = ({
            UNKNOWN: 'far fa-lg fa-question-circle',
            ACTIVE: 'far fa-lg fa-check-circle',
            PENDING: 'far fa-lg fa-clock',
            PAUSED: 'far fa-lg fa-circle-pause',
        })[status];
    }
    return statusIconClass;
}

export function companyUserStatusTextClass(status, blockedStatus) {
    let statusTextClass;
    if (blockedStatus && blockedStatus != 'NONE') {
        statusTextClass = 'text-ban'
    } else {
        statusTextClass = ({
            UNKNOWN: 'text-muted',
            ACTIVE: 'text-success',
            PENDING: 'text-warning',
            PAUSED: 'text-warning',
        })[status];
    }
    return statusTextClass;   
}


// WEBPACK FOOTER //
// ./src/portal/components/sp-user-status/sp-user-status.exports.js